import { css } from "lit";
var componentStyles = css`:host{position:relative;box-sizing:border-box}:host *,:host ::after,:host ::before{box-sizing:inherit}[hidden]{display:none!important}`;
export { componentStyles as default };
